import { useEffect, useState } from "react"

/**
 * Hook dùng để debounce giá trị (ví dụ text search) trong một khoảng delay nhất định.
 *
 * @param value Giá trị cần debounce
 * @param delay Thời gian delay (ms)
 * @returns Giá trị đã debounce
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
